import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ChangePasswordView = angular
  .module('acme.view.changePassword', [uiRouter, 'ui.bootstrap', 'acme.view.changePassword.controllers'])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const changePassword = {
      name: 'changePassword',
      url: '/changePassword',
      abstract: true,
      views: {
        main: {
          controller: 'ChangePasswordController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
    };

    const changePasswordDefault = {
        name: 'changePassword.default',
        url: '',
        views: {
          'subview-main': {
            templateUrl: 'views/changePassword/changePassword.tpl.html',
          },
        },
        data: {
          pageTitle: 'Change your password',
          rule: function (exclusions) {
            // Allow if state is not in exclusions array
            return exclusions.indexOf('changePassword.default') !== -1;
          },
        },
      },
      changePasswordToken = {
        name: 'changePassword.token',
        url: '/:token',
        views: {
          'subview-main': {
            controller: 'changePasswordToken',
            templateUrl: 'views/changePassword/changePassword.tpl.html',
          },
        },
      };

    $stateProvider.state(changePassword).state(changePasswordDefault).state(changePasswordToken);
  }).name;
